import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import ProductionBoard from "./pages/ProductionBoard";
import Customers from "./pages/Customers";
import Products from "./pages/Products";
import Matching from "./pages/Matching";
import Inventory from "./pages/Inventory";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Settings from "./pages/Settings";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-slate-400">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/board" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="/board" element={<ProductionBoard />} />
              <Route path="/orders" element={<Protected adminOnly><Orders /></Protected>} />
              <Route path="/customers" element={<Protected adminOnly><Customers /></Protected>} />
              <Route path="/products" element={<Protected adminOnly><Products /></Protected>} />
              <Route path="/inventory" element={<Protected adminOnly><Inventory /></Protected>} />
              <Route path="/reports" element={<Protected adminOnly><Reports /></Protected>} />
              <Route path="/matching" element={<Protected adminOnly><Matching /></Protected>} />
              <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
              <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
